import React, { useState, useRef, useEffect } from "react";

const FilterColumns = ({ columns, onToggle, onToggleAll }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const toggleAll = () => {
    onToggleAll();
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="filter-columns" ref={containerRef}>
      <div className="dropdown" style={{ width: "200px" }}>
        <button
          className="form-control dropdown-toggle"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
        >
          Hide Columns
        </button>
        {isOpen && (
          <div
            className="dropdown-menu"
            style={{ display: "block", width: "200px", zIndex: "9999" }}
          >
            <div className="p-2">
              {columns && columns.length !== 0 ? (
                columns.map((column, index) => (
                  <div
                    className="mb-2 hideColumn"
                    key={index}
                    onClick={() => onToggle(column)}
                  >
                    <i
                      className="fas fa-times fa-bold"
                      style={{ color: "#990000" }}
                    ></i>{" "}
                    <span className="ml-1" title="Unhide">
                      {column.name}
                    </span>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    textAlign: "center",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#8c8c8c",
                    }}
                  >
                    No hidden columns
                  </span>
                </div>
              )}
              {columns && columns.length !== 0 && (
                <>
                  <div className="dropdown-divider"></div>
                  <div
                    className="form-group"
                    style={{
                      marginBottom: "0",
                      marginTop: "20px",
                      fontSize: "14px",
                      color: "#0059b3",
                      textAlign: "center",
                    }}
                  >
                    <span className="text" onClick={toggleAll}>
                      Unhide All
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterColumns;
